<template>
  <div>
    <div class="policies pt-0">
      <div class="row justify-content-center">
        <div class="col-12">
          <div class="policies__head">
            <div class="policies__head__title">
              <span>P&oacute;lizas</span>
              <div class="dropdown-container" v-if="userRole !== 'ReadOnly'">
                <!-- <button @click="downloadReport()" :disabled="downloading">
                    <span v-if="!downloading">Descargar reporte</span>
                    <span v-if="downloading">Descargando...</span>
                  </button> -->
                <b-dropdown id="dropdown-1" class="m-md-2">
                  <template #button-content>
                    <span v-if="!downloading">Descargar Reportes</span>
                    <span v-if="downloading">Descargando reporte...</span>
                  </template>
                  <li>
                    <b-dropdown-item @click="downloadReport()">&nbsp;&nbsp;&nbsp;P&oacute;lizas</b-dropdown-item>
                  </li>
                  <li>
                    <b-dropdown-item @click="downloadPaymentsReport()">&nbsp;&nbsp;&nbsp;Pagos</b-dropdown-item>
                  </li>
                  <li>
                    <b-dropdown-item @click="downloadReservationsReport()">&nbsp;&nbsp;&nbsp;Reservas</b-dropdown-item>
                  </li>
                  <li>
                    <b-dropdown-item @click="downloadCustomReport()">&nbsp;&nbsp;&nbsp;Personalizado</b-dropdown-item>
                  </li>
                </b-dropdown>
              </div>
            </div>
          </div>
          <div class="policies__body">
            <div class="row">
              <div class="col-md-12">
                <div class="policies__input-dates">
                  <div class="policies__input-dates__input">
                    <small>Ingresa tu b&uacute;squeda</small>
                    <div class="input-group mb-3">
                      <input type="text" class="form-control" placeholder="Ingrese búsqueda" aria-label="Username"
                        aria-describedby="basic-addon1" v-model="query.q" @keyup.native.enter="loadPolicies()" />
                    </div>
                  </div>

                  <div class="policies__input-dates__start-date">
                    <div class="input-group mb-3">
                      <small>Buscar desde:</small>
                      <datepicker v-model:model-value="query.startDate" :clearable="false" :placeholder="'Desde'">
                      </datepicker>
                      <button class="clear-date" @click="clearDate(true)">
                        ✕
                      </button>
                    </div>
                  </div>

                  <div class="policies__input-dates__end-date">
                    <small>Buscar hasta:</small>
                    <div class="input-group mb-3">
                      <datepicker v-model:model-value="query.endDate" :clearable="false" :placeholder="'Hasta'">
                      </datepicker>
                      <button class="clear-date" @click="clearDate(false)">
                        ✕
                      </button>
                    </div>
                  </div>

                  <div class="policies__input-dates__end-date">
                    <small>Estado de p&oacute;lizas:</small>
                    <div class="input-group mb-3">
                      <select name="" id="" class="form-control" v-model="query.status">
                        <option value="-1">Todas</option>
                        <option value="1">Activas</option>
                        <option value="0">Anuladas</option>
                        <option value="2">Congeladas</option>
                        <option value="3">Deuda pendiente</option>
                      </select>
                    </div>
                  </div>

                  <div class="policies__input-dates__end-date">
                    <small>Estado d&eacute;bito:</small>
                    <div class="input-group mb-3">
                      <select name="" id="" class="form-control" v-model="query.debitStatus">
                        <option value="-1">Todas</option>
                        <option value="1">Con D&eacute;bito Autom&aacute;tico</option>
                        <option value="0">Sin D&eacute;bito Autom&aacute;tico</option>
                      </select>
                    </div>
                  </div>

                  <div class="policies__input-dates__btn-policies">
                    <small class="invisible d-block">.</small>
                    <button type="button" class="btn btn-primary" @click="loadPolicies()">
                      Buscar
                    </button>
                  </div>
                </div>

                <div class="text-center text-main" v-if="flags.searching">
                  <i class="fas fa-circle-notch fa-spin d-block mb-1"></i>
                  Cargando p&oacute;lizas...
                </div>
                <div class="policies__body__table">
                  <table class="table table-hover table-striped" v-if="!flags.searching">
                    <thead>
                      <tr>
                        <!-- <th>N</th> -->
                        <th>P&oacute;liza</th>
                        <th>Nombre</th>
                        <th>DNI</th>
                        <th>Prima</th>
                        <th>Acumulado</th>
                        <th>Primas pendientes</th>
                        <th>DA</th>
                        <th>Fecha de compra</th>
                        <th>Nro. Años</th>
                        <th>Devolución</th>
                        <th>Estado</th>
                        <!--th v-if="isSuperAdmin"></th-->
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in policies" v-bind:key="item.policyId">
                        <td>
                          <router-link :to="{
                            name: 'admineditpolicy',
                            query: { policyNumber: item.policyNumber },
                          }">
                            {{ item.policyNumber }}
                          </router-link>
                        </td>
                        <td>
                          <div>
                            {{ item.user.firstName }} {{ item.user.lastName }}
                          </div>
                          <div>
                            <small>({{ item.user.email }})</small>
                          </div>
                        </td>
                        <td>
                          {{ item.user.identificationNumber }}
                        </td>
                        <td>S/{{ item.paymentAmount }}</td>
                        <td>S/{{ item.totalAmountSaved }}</td>
                        <td>{{ item.pendingPayments }}</td>
                        <td>{{ item.debitAutomatic ? "Si" : "No" }}</td>
                        <td>{{ formatDate(item.createdOn) }}</td>
                        <td class="text-center">{{ item.periodicity }}</td>
                        <td>
                          S/{{ formatNumber(item.totalAmountSavedFinal) }}
                        </td>
                        <td>
                          <template v-if="item.entityStatus === 0">
                            <span class="badge badge-danger">Anulada</span>
                          </template>
                          <template v-if="item.entityStatus === 1">
                            <span class="badge badge-info" v-if="item.freezed">Congelada</span>
                            <span class="badge badge-success" v-if="!item.freezed">Activa</span>
                          </template>
                        </td>
                        <!--td class="text-right" v-if="isSuperAdmin">
                          <template v-if="!item.loading && item.entityStatus === 1">
                            <button role="button" class="delete" @click="openCancelConfirmModal(item)">
                              <i class="fas fa-times mr-1"></i>
                              <span>Anular</span>
                            </button>
                          </template>
                          <i class="fas fa-circle-notch fa-spin" v-if="item.loading"></i>
                        </td-->
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div class="pagination" v-if="policies && policies.length > 0">
                  <pagination v-model="page" :records="rowCount" :per-page="20" @paginate="changePage" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal id="modal-error" ok-only ok-title="Entiendo" centered size="md" modal-class="modal-blue" ref="modal-error">
      <div class="modal-error__head">
        <img :src="require('@/assets/images/app/alert.svg')" alt="" />
        <h3>Ups!</h3>
      </div>
      <div class="modal-error__head">
        <p>
          {{ errors.message }}
        </p>
      </div>
    </b-modal>

    <b-modal id="modal-confirm" ok-only ok-title="Esta seguro de anular la poliza?" centered size="sm"
      modal-class="modal-blue" ref="modal-confirm">
      <div class="modal-blue__head pt-2">
        <i class="fas fa-timex fa-3x text-danger"></i>
        <h3>Anular P&oacute;liza</h3>
      </div>
      <div class="modal-blue__head" v-if="selectedPolicy">
        <p>
          ¿Esta seguro de anular la póliza
          {{ selectedPolicy.referencePolicyNumber }}?
        </p>
        <div class="d-flex justify-content-between">
          <button class="btn btn-default" style="color: #fff" @click="closeModal('modal-confirm')">
            Cerrar
          </button>
          <button class="btn btn-danger" type="button" @click="cancel()" :disabled="deleting">
            <span v-if="!deleting">Anular</span>
            <span v-if="deleting">Anulando p&oacute;liza...</span>
          </button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script lang="ts">
import { BButton, BModal, VBModal, BCardText, BDropdown } from "bootstrap-vue";

/**DATEPICKER */

//import Datepicker from 'vue3-datepicker';

// import DatePicker from 'vue-datepicker-next';
// import 'vue-datepicker-next/index.css';

// import Datepicker from "vuejs-datepicker";
import Datepicker from "vue3-datepicker";
// import Datepicker from '@vuepic/vue-datepicker';
import Vuelidate from "vuelidate";
import es from "vuejs-datepicker/dist/locale/translations/es";
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/antd.css";
import {
  required,
  minLength,
  maxLength,
  email,
  numeric,
  sameAs,
  requiredIf,
} from "vuelidate/lib/validators";
import axios from "axios";
import valid from "card-validator";
import moment from "moment";
import { init } from "echarts/lib/echarts";
import { environment } from "../../../environment/environment";
import { ref, defineComponent } from "vue";
import pagination from "vue-pagination-2";

//import '@vuepic/vue-datepicker/dist/main.css'
import { quartersInYear } from "date-fns";

export default defineComponent({
  components: {
    BCardText,
    VueSlider,
    BModal,
    pagination,
    // DatePicker,
    Datepicker,
    BDropdown,
  },
  data() {
    return {
      apiUrl: environment.api,
      isApiCancel: environment.isApiCancel,
      basePath: window["basePath"],
      policies: [],
      firstLoad: true,
      flags: {
        loading: false,
        searching: false,
      },
      es: es,
      errors: {
        message: "",
      },
      query: {
        q: "",
        startDate: null,
        endDate: null,
        status: -1,
        debitStatus: -1
      },
      page: 1,
      rowCount: 0,
      downloading: false,
      deleting: false,
      selectedPolicy: null,
      isSuperAdmin: false,
      userRole: ""
    };
  },
  validations: function () {
    return {};
  },
  created() {
    this.init();
  },
  watch: {},
  methods: {
    init() {
      this.getUser();
      this.loadPolicies();
    },
    getUser() {
      let user: any = JSON.parse(localStorage.getItem("__user__"));
      this.user = user;

      this.userRole = user.roles[0];

      if(user.roles && user.roles.length > 0 && user.roles[0] === 'Admin') {
        this.isSuperAdmin = true;
      }
    },
    clearDate(t = false) {
      if (t) {
        this.query.startDate = null;
      } else {
        this.query.endDate = null;
      }
    },
    async loadPolicies() {
      this.flags.searching = true;
      this.policies = [];
      let auth = JSON.parse(window.localStorage.getItem("__auth__"));
      let headers = {
        headers: {
          Authorization: auth.token_type + " " + auth.access_token,
        },
      };

      let url = `${this.apiUrl}policies/all?page=${this.page}&pageSize=20&q=${this.query.q}`;

      if (this.query.startDate) {
        url += `&startDate=${moment(this.query.startDate).format(
          "MM-DD-YYYY"
        )}`;
      }

      if (this.query.endDate) {
        url += `&endDate=${moment(this.query.endDate).format("MM-DD-YYYY")}`;
      }

      if (this.query.status >= 0) {
        url += `&status=${this.query.status}`;
      }

      if (this.query.debitStatus >= 0) {
        url += `&debitStatus=${this.query.debitStatus}`;
      }

      var result = await axios.get(url, headers);

      try {
        if (result.data) {
          let data = result.data;

          data = data.results.map((el) => {
            el.loading = false;
            el.policyNumber = el.referencePolicyNumber
              ? el.referencePolicyNumber.substring(1, el.referencePolicyNumber)
              : "";
            return el;
          });
          this.policies = data;
          this.rowCount = result.data.rowCount;
          this.flags.searching = false;
          this.firstLoad = false;
        }
      } catch (error) {
        console.log(error);
      }
      this.flags.searching = false;
    },
    changePage(event) {
      this.page = event;
      this.loadPolicies();
    },
    formatDate(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    async cancel() {
      let url = `${this.apiUrl}policies/${this.selectedPolicy.policyId}/delete`;

      this.deleting = true;

      let model = {};
      let auth = JSON.parse(window.localStorage.getItem("__auth__"));
      console.log(auth);
      let headers = {
        headers: {
          Authorization: auth.token_type + " " + auth.access_token,
        },
        data: {
          source: {},
        },
      };
      try {
        let result = await axios.delete(url, headers);
        if (result.data !== undefined) {
          this.cancelRumboBD()
          this.loadPolicies();
          this.$refs["modal-confirm"].hide();
        }
          this.deleting = false;

      } catch (error) {
        this.deleting = false;
        this.errors.message = error.response.data.detail.substring(0, 150) + "...";
        this.$refs["modal-error"].show();
      }
    },
    async cancelRumboBD() {
      //método para anular póliza en la nueva bd de rumbo.
      let model = {
          numeroPoliza: '0'+ this.selectedPolicy.policyNumber
        };
        console.log(model);
        var result = await axios.post(`${this.isApiCancel}`, model);
    },
    async downloadReservationsReport() {
      this.downloading = true;
      let url = `${this.apiUrl}policies/reservations-report`;

      let model = {};
      let auth = JSON.parse(window.localStorage.getItem("__auth__"));
      console.log(auth);
      let headers: any = {
        headers: {
          Authorization: auth.token_type + " " + auth.access_token,
        },
        responseType: "blob",
        data: {
          source: {},
        },
      };

      try {
        let result = await axios.post(url, {}, headers);
        if (result.data !== undefined) {
          let blob = new Blob([result.data], {
            type: "application/vnd.ms-excel",
          });
          let url = window["URL"].createObjectURL(blob);
          let a = document.createElement("a");
          a.href = url;
          a.download = "Reporte_Reservas.xlsx";
          a.click();
          window["URL"].revokeObjectURL(url);

          this.downloading = false;
        }
      } catch (error) {
        this.downloading = false;
      }
    },
    async downloadPaymentsReport() {
      this.downloading = true;
      let url = `${this.apiUrl}policies/payments-report`;

      let model = {};
      let auth = JSON.parse(window.localStorage.getItem("__auth__"));
      console.log(auth);
      let headers: any = {
        headers: {
          Authorization: auth.token_type + " " + auth.access_token,
        },
        responseType: "blob",
        data: {
          source: {},
        },
      };

      try {
        let result = await axios.post(url, {}, headers);
        if (result.data !== undefined) {
          let blob = new Blob([result.data], {
            type: "application/vnd.ms-excel",
          });
          let url = window["URL"].createObjectURL(blob);
          let a = document.createElement("a");
          a.href = url;
          a.download = "Reporte_Pagos.xlsx";
          a.click();
          window["URL"].revokeObjectURL(url);

          this.downloading = false;
        }
      } catch (error) {
        this.downloading = false;
      }
    },
    async downloadReport() {
      this.downloading = true;
      let url = `${this.apiUrl}policies/report`;

      let model = {};
      let auth = JSON.parse(window.localStorage.getItem("__auth__"));
      console.log(auth);
      let headers: any = {
        headers: {
          Authorization: auth.token_type + " " + auth.access_token,
        },
        responseType: "blob",
        data: {
          source: {},
        },
      };

      try {
        let result = await axios.post(url, {}, headers);
        if (result.data !== undefined) {
          let blob = new Blob([result.data], {
            type: "application/vnd.ms-excel",
          });
          let url = window["URL"].createObjectURL(blob);
          let a = document.createElement("a");
          a.href = url;
          a.download = "Reporte_Polizas.xlsx";
          a.click();
          window["URL"].revokeObjectURL(url);

          this.downloading = false;
        }
      } catch (error) {
        this.downloading = false;
      }
    },
    async downloadCustomReport() {
      this.downloading = true;

      let model = {};
      let auth = JSON.parse(window.localStorage.getItem("__auth__"));

      let headers: any = {
        Headers: {
          Authorization: auth.token_type + " " + auth.access_token,
        },
        responseType: "blob",
        data: {
          source: {},
        }
      };

      let url = `${this.apiUrl}policies/custom-report?page=${this.page}&pageSize=20&q=${this.query.q}`;

      if (this.query.startDate) {
        url += `&startDate=${moment(this.query.startDate).format(
          "MM-DD-YYYY"
        )}`;
      }

      if (this.query.endDate) {
        url += `&endDate=${moment(this.query.endDate).format("MM-DD-YYYY")}`;
      }

      if (this.query.status >= 0) {
        url += `&status=${this.query.status}`;
      }

      if (this.query.debitStatus >= 0) {
        url += `&debitStatus=${this.query.debitStatus}`;
      }

      try {
        let result = await axios.get(url, headers);
        if (result.data !== undefined) {
          let blob = new Blob([result.data], {
            type: "application/vnd.ms-excel",
          });
          let url = window["URL"].createObjectURL(blob);
          let a = document.createElement("a");
          a.href = url;
          a.download = "Custom_Report.xlsx";
          a.click();
          window["URL"].revokeObjectURL(url);

          this.downloading = false;
        }

      } catch (error) {
        this.downloading = false;
      }
    },

    openCancelConfirmModal(item) {
      this.selectedPolicy = item;
      this.$refs["modal-confirm"].show();
    },
    closeModal(modal) {
      this.$refs[modal].hide();
    },
    formatNumber(number) {
      return number.toLocaleString("en-US");
    },
  },
});
</script>

<style lang="scss">
/**/
@import "../../../styles/abstracts/variables";
/**/

.policies {
  &__head {
    &__title {
      font-weight: 500;
      font-size: 28px;
      color: #0855c4;
      display: flex;
      width: 100%;
      align-items: center;
      justify-content: space-between;

      button {
        padding: 8px 25px 8px 25px;
        font-weight: 500;
        border-radius: 5px;
        border: none;
        font-size: 14px;
        color: white;
        background-color: $primaryBlue;
      }
    }
  }

  &__body {
    .row {
      margin: 50px 0px 0px 0px;

      .col-md-12 {
        padding: 0;

        .table {
          thead {
            tr {
              th {
                vertical-align: top;
                text-transform: uppercase;
                font-size: 12px;
                letter-spacing: 0.5px;
                color: $primaryGray;
                padding: 0.72rem 1rem;
                border-bottom: 2px solid #ebe9f1;
                background-color: #f3f2f7;
              }
            }
          }

          tbody {
            tr {
              background-color: white;

              td {
                font-size: 14px;
                color: $primaryGray;
                border: none;
                padding: 0.72rem 1rem;
                vertical-align: middle;
                border-top: 1px solid #ebe9f1;

                a {
                  text-decoration: none;
                  color: $primaryBlue !important;
                }

                .delete {
                  display: flex;
                  align-items: center;
                  color: $primaryRed;
                  background-color: transparent;
                  border: none;

                  span {
                    display: block;
                    padding-left: 10px;
                  }
                }

                .badge-success {
                  background-color: $green;
                }

                .badge-danger {
                  background-color: $primaryRed;
                }

                .badge-info {
                  background-color: $info;
                }
              }
            }

            tr:nth-child(even) {
              background-color: transparent;
            }
          }
        }

        .table> :not(caption)>*>* {
          box-shadow: none;
        }
      }
    }
  }

  &__input-dates {
    display: flex;

    &__input {
      width: 280px;
    }

    &__start-date {
      width: 200px;
      margin-left: 22px;
      margin-right: 9px;
    }

    &__end-date {
      width: 200px;
      margin-right: 10px;
    }

    /*

        &__start-date,
        &__end-date {
            .input-group {
                position: relative;
                width: 100%;

                input[type=text] {
                    display: block;
                    width: 100%;
                    padding: 0.375rem 0.75rem;
                    font-size: 1rem;
                    font-weight: 400;
                    line-height: 1.5;
                    color: #212529;
                    background-color: #fff;
                    background-clip: padding-box;
                    outline: no;
                    border: 1px solid #ced4da;
                    -webkit-appearance: none;
                    -moz-appearance: none;
                    appearance: none;
                    border-radius: 0.375rem;
                    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
                }


                button {
                    position: absolute;
                    font-weight: 500;
                    top: 8px;
                    right: 5px;
                    border: none;
                    font-size: 15px;
                    color: $primaryGray;
                    background-color: transparent;
                }
            }

            .dp__clear_icon {
                display: none;
            }



        }
        */

    &__btn-policies {
      .btn-primary {
        margin-left: 10px;
        width: 200px;
      }
    }
  }
}

.pagination {
  margin-top: 15px;

  @media (min-width: $desktopBreak) {
    display: flex;
    justify-content: flex-end;
  }
}

.VuePagination__count {
  display: none;
}

.modal-blue {
  .modal-dialog {
    .modal-content {
      background-color: $mainColor;

      .modal-footer,
      .modal-header {
        display: none !important;
      }
    }
  }

  &__head {
    color: #fff;
    text-align: center;

    h3 {
      font-weight: bolder;
      color: $thirdColor;
    }

    i {
      margin-bottom: 10px;
      color: $thirdColor;
    }

    p {
      a {
        color: #fff;
        text-decoration: underline;
      }
    }
  }

  &__body {
    p {
      font-size: 14px;
      color: #fff;
    }
  }
}

/**DATEPICKER */
.v3dp__datepicker {
  input {
    color: #212529;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    border-radius: 5px;
    height: 38px;
    padding: 14px;
  }
}

.clear-date {
  position: absolute;
  font-weight: 500;
  bottom: 6px;
  right: 20px;
  border: none;
  font-size: 15px;
  color: $primaryGray;
  background-color: transparent;
}

.dropdown-container {
  .dropdown-menu {
    width: 100%;
    left: auto !important;
    right: 0 !important;
  }

  li {
    cursor: pointer;
  }

  li:hover {
    background-color: #0d6efd !important;
    color: #fff;
  }
}
</style>
